import React from "react";
import { useNavigate } from "react-router-dom";
import CustomTable from "../../widgets/Table/CustomTable";
import PrimaryButton from "../../widgets/Buttons/PrimaryButton";
import TertiaryButton from "../../widgets/Buttons/TertiaryButton";
import SecondaryButton from "../../widgets/Buttons/SecondaryButton";
import styles from "./OrderTable.module.scss";

const OrderTable = ({
  title = "Orders",
  orders = [],
  isLoading = false,
  fetchError = null,
  actionableStatusIds = [],
  isOrderLoading = () => null,
  onAccept,
  onReject,
}) => {
  const navigate = useNavigate();

  const columns = [
    {
      id: "order_id",
      label: "Order ID",
      render: (row) => <span className={styles.orderId}>{row.order_id}</span>,
    },
    {
      id: "amount_paid",
      label: "Amount Paid",
      render: (row) => `₹${row.amount_paid?.toLocaleString("en-IN")}`,
    },
    {
      id: "amount",
      label: "Order Amount",
      render: (row) => `₹${row.amount?.toLocaleString("en-IN")}`,
    },
    {
      id: "status",
      label: "Status",
      render: (row) => (
        <span
          className={`${styles.statusBadge} ${
            styles[`status_${row.status?.id}`] || ""
          }`}
        >
          {row.status?.name || "-"}
        </span>
      ),
    },
    {
      id: "actions",
      label: "Actions",
      render: (row) => {
        const actionable = actionableStatusIds.includes(row.status?.id);
        const loadingAction = isOrderLoading(row.order_id);
        const isAcceptLoading = loadingAction === "accept";
        const isRejectLoading = loadingAction === "reject";
        const isRowLoading = !!loadingAction;

        return actionable ? (
          <div className={styles.actions}>
            <PrimaryButton
              onClick={() => onAccept?.(row)}
              isLoading={isAcceptLoading}
              disabled={isRowLoading}
              sx={{ height: "36px", minWidth: "100px" }}
            >
              Accept
            </PrimaryButton>
            <TertiaryButton
              onClick={() => onReject?.(row)}
              isLoading={isRejectLoading}
              disabled={isRowLoading}
              sx={{ height: "36px", minWidth: "100px" }}
            >
              Reject
            </TertiaryButton>
          </div>
        ) : (
          <span className={styles.noAction}>—</span>
        );
      },
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.title}>{title}</h2>
        <SecondaryButton
          onClick={() => navigate(-1)}
          sx={{ height: "36px", minWidth: "80px" }}
        >
          Back
        </SecondaryButton>
      </div>

      <div className={styles.tableWrapper}>
        {fetchError ? (
          <div className={styles.noData}>
            Could not load orders. Please try again.
          </div>
        ) : (
          <CustomTable
            columns={columns}
            data={orders}
            isLoading={isLoading}
            noDataMessage={`No orders found for ${title.toLowerCase()}.`}
            sx={{ border: "none" }}
          />
        )}
      </div>
    </div>
  );
};

export default OrderTable;
